import { useCallback, useEffect, useState } from "react";
import { Users } from "lucide-react";
import { C, font } from "../theme";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { Button } from "../components/Button";
import { TeamInvitePanel } from "../components/TeamInvitePanel";
import { useSession } from "../lib/session/SessionContext";
import { listTenantMembers } from "../lib/api/endpoints";
import type { TenantMemberDto } from "../types";

interface OnboardingTeamScreenProps {
  onComplete: () => void;
}

export function OnboardingTeamScreen({ onComplete }: OnboardingTeamScreenProps) {
  const { accessToken, activeTenant } = useSession();
  const [members, setMembers] = useState<TenantMemberDto[]>([]);

  const loadMembers = useCallback(async () => {
    if (!accessToken) return;
    try {
      setMembers(await listTenantMembers(accessToken));
    } catch {
      // listagem é secundária no onboarding; falha não bloqueia o fluxo
    }
  }, [accessToken]);

  useEffect(() => {
    void loadMembers();
  }, [loadMembers]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: font,
      }}
    >
      <ApogeuLogo width={140} />
      <div style={{ fontSize: 12, letterSpacing: 4, color: C.light, marginTop: 12, marginBottom: 24 }}>
        CONVIDE SUA EQUIPE
      </div>
      <div style={{ fontSize: 13, color: C.gray, maxWidth: 400, lineHeight: 1.6, textAlign: "center", marginBottom: 20 }}>
        {activeTenant ? <>Adicione os funcionários do CT <strong style={{ color: C.ink }}>{activeTenant.name}</strong> para gerar os links de acesso.</> : "Adicione os funcionários do CT para gerar os links de acesso."}
      </div>

      <div style={{ width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", gap: 14 }}>
        <TeamInvitePanel />

        {members.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <div style={{ fontSize: 11, letterSpacing: 1, color: C.gray, fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
              <Users size={13} /> MEMBROS DO CT
            </div>
            {members.map(m => (
              <div key={m.userId} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, border: `1px solid ${C.faint}`, borderRadius: 10, padding: "9px 12px" }}>
                <span style={{ fontSize: 12.5, fontWeight: 600, color: C.ink }}>{m.displayName}</span>
                <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 1, color: C.ink, background: C.limeSoft, padding: "3px 9px", borderRadius: 20, textTransform: "uppercase" }}>
                  {m.roleSlug}
                </span>
              </div>
            ))}
          </div>
        )}

        <Button variant="dark" onClick={onComplete} style={{ fontSize: 13, padding: "12px 14px", marginTop: 4 }}>
          Entrar no painel
        </Button>
      </div>
    </div>
  );
}